<template>
    <form
        @submit.prevent="handleSubmit"
        class="form-container cover-search-form covervault"
        data-cy="cover-search-container"
    >
        <div class="flex w-full">
            <div class="flex flex-col w-3/4 md:w-4/5 pr-2" data-cy="cover-search">
                <ui-input
                    data-cy="cover-search-field"
                    v-model="search_form.basic_search"
                    class="p-6 border-default-blue-green"
                    :placeholder="$t('covers.public.placeholder')"
                    @updatedValue="handleReset"
                />
            </div>
            <div class="flex flex-col w-1/4 md:w-1/5 pl-2">
                <a-button
                    @click="handleSubmit"
                    type="submit"
                    class="bg-default-blue-green hover:bg-default-blue-green focus:bg-default-blue-green active:bg-default-blue-green 3xl:w-2/3 sm:text-xl text-lg h-full ant-btn-primary sm:px-4 px-0"
                    data-cy="cover-search-button"
                    :disabled="processing"
                >
                    <span v-if="!processing">{{ $t('covers.public.search') }}</span>
                    <span v-else>{{ $t('covers.public.searching') }}</span>
                </a-button>
            </div>
        </div>
        <div class="flex flex-col items-center pt-2">
            <div
                data-cy="cover-search-field-length-error"
                :class="{ 'text-default-red': v$.search_form.basic_search.$error }"
                v-if="v$.search_form.basic_search.minLength.$invalid && v$.search_form.basic_search.$error"
            >
                {{
                    $t('validation.min.string', {
                        attribute: 'search',
                        min: association.public_cover_search_min_search_value,
                    })
                }}
            </div>
            <div
                :class="{ 'text-default-red': v$.search_form.basic_search.$error }"
                data-cy="cover-search-field-error"
                v-if="v$.search_form.basic_search.required.$invalid && v$.search_form.basic_search.$error"
            >
                {{ $t('validation.required') }}
            </div>
        </div>
    </form>
</template>

<script>
import UiInput from '@/components/ui/Input.vue';

import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        UiInput,
    },
    props: {
        association: Object,
        processing: {
            type: Boolean,
            default: false,
        },
        search_form: {
            type: Object,
            default: {},
        },
    },
    validations: {
        search_form: {
            basic_search: {
                required,
                minLength(value) {
                    if (this.association.public_cover_search_min_search_value > 0) {
                        return value.length >= this.association.public_cover_search_min_search_value;
                    }

                    return true;
                },
            },
        },
    },
    methods: {
        async handleSubmit() {
            if (!(await this.v$.$validate())) return false;

            this.$emit('formSubmit');
        },
        handleReset() {
            this.$emit('reset');
        },
    },
};
</script>
